import { Transaction, PaginationInfo, TransactionsResponse } from "../models";

export const getTransactions = (responseData: any): TransactionsResponse => {
  // Extract transaction data
  const transactions = responseData.data.map(getTransaction);

  // Extract pagination information
  const pagination: PaginationInfo = {
    currentPage: responseData.current_page,
    lastPage: responseData.last_page,
    perPage: responseData.per_page,
    total: responseData.total,
    hasNextPage: responseData.next_page_url !== null,
    hasPrevPage: responseData.prev_page_url !== null,
    nextPageUrl: responseData.next_page_url,
    prevPageUrl: responseData.prev_page_url,
  };

  return {
    transactions,
    pagination,
  };
};

export const getTransaction = (data: any): Transaction => {
  return {
    id: data.id,
    total: data.total,
    createdAt: data.created_at,
    status: data.status,
    type: data.type,
    customerName: data.customer
      ? `${data.customer.firstname} ${data.customer.lastname}`
      : "",
    customerEmail: data.customer ? data.customer.email : "",
    cardLastFour: data.last_four,
  };
};
